import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { beneficiary_change_form_keys_previdential_intros, IPrevidentialBeneficiaryType } from './beneficiary-change-isp.constants';
import { LoggerService } from 'src/app/services/logger.service';
import { take } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { CLOSE_BUTTON, CONFIRM_BUTTON, EModalOutput } from 'src/app/modules/shared/components/basic-modal/basic-modal.constants';
import { BeneficiaryFormIsvComponent } from '../beneficiary-form-isv/beneficiary-form-isv.component';
import { EPolicyCompany, IBeneficiarioPrevidenziale, IPagatore, UserActivityScope } from 'src/app/modules/shared/models/policy.model';
import { IFormKey, IFormSelectOption } from 'src/app/modules/shared/models/forms';
import { CommonUtils } from 'src/app/utils/CommonUtils';
import { residence_change_previdence_form_group_config } from '../residence-change-isv/residence-change-isv.constants';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-beneficiary-change-isp',
  templateUrl: './beneficiary-change-isp.component.html',
  styleUrl: './beneficiary-change-isp.component.scss'
})
export class BeneficiaryChangeIspComponent implements OnChanges {
  @Input() currentBeneficiaries: IBeneficiarioPrevidenziale[]
  @Input() beneficiariesTypes: IFormSelectOption[]
  @Input() holderBeneficiaryRelationshipList: IFormSelectOption[]
  @Input() countriesList: IFormSelectOption[]
  @Input() provinceList: IFormSelectOption[]
  @Input() comuniList: IFormSelectOption[]

  @Output() emitBeneficiariesList = new EventEmitter<IBeneficiarioPrevidenziale[]>();
  @Input() form: FormGroup;
  
  
  public keys: IFormKey[] = CommonUtils.assign(beneficiary_change_form_keys_previdential_intros)

  ngOnInit(): void { 

  }

  constructor(private readonly _dialog: MatDialog){

  }

  removeBeneficiary(beneficiary: IBeneficiarioPrevidenziale): void {
      this.currentBeneficiaries = this.currentBeneficiaries.filter(x => x.codiceFiscale !== beneficiary.codiceFiscale)
      LoggerService.logInfo(this.constructor.name, 'removeBeneficiary', { beneficiary });
      this.emitBeneficiariesList.emit(this.currentBeneficiaries);
  }

  openDetail(beneficiary: IBeneficiarioPrevidenziale): void {
    this._dialog.open(BeneficiaryFormIsvComponent, {
      data: {
        policyCompany: EPolicyCompany.ISP,
        userActivityScope: UserActivityScope.BENEFICIARIO_PREVIDENZIALE,
        beneficiaryType: this.beneficiariesTypes,
        holderBeneficiaryRelationshipList: this.holderBeneficiaryRelationshipList,
        provincesList: this.provinceList,
        comuniList: this.comuniList,
        isReadOnly: false,
        countriesList: this.countriesList,
        beneficiaryData: beneficiary
      },
      minWidth: '70vw',
      minHeight: '55vh',
      disableClose: true
    });
  }

  openNewBeneficiaryModal(): void {
    this._dialog.open(BeneficiaryFormIsvComponent, {
      data: {
        policyCompany: EPolicyCompany.ISP,
        userActivityScope: UserActivityScope.BENEFICIARIO_PREVIDENZIALE,
        beneficiaryType: this.beneficiariesTypes,
        holderBeneficiaryRelationshipList: this.holderBeneficiaryRelationshipList,
        provincesList: this.provinceList,
        comuniList: this.comuniList,
        isReadOnly: false,
        countriesList: this.countriesList,
        buttons: [
          CLOSE_BUTTON,
          CONFIRM_BUTTON
        ]
      },
      minWidth: '70vw',
      minHeight: '55vh',
      disableClose: true
    })
      .afterClosed()
      .pipe(take(1))
      .subscribe(outcome => {
        if (outcome && outcome.command === EModalOutput.CONFIRM) {
          LoggerService.logInfo(this.constructor.name, 'openNewBeneficiaryModal', { outcome });

          this.currentBeneficiaries.push({
            nome: outcome.output.beneficiaries.beneficiario.nome,
            ragioneSociale: outcome.output.beneficiaries.beneficiario.ragioneSociale,
            partitaIva: outcome.output.beneficiaries.beneficiario.partitaIVA,
            cognome: outcome.output.beneficiaries.beneficiario.cognome,
            codiceFiscale: outcome.output.beneficiaries.beneficiario.codiceFiscale,
            perc_Beneficio: outcome.output.beneficiaries.beneficiario.perc_Beneficiorio,
            codicebeneficiario: outcome.output.beneficiaries.beneficiario.codicebeneficiario,
            anagrafico: outcome.output.beneficiaries.personData?.idAnagrafico,
            tipoPersona: outcome.output.beneficiaries.beneficiario.personType,
            localitaNascita: outcome.output.beneficiaries.anagrafica?.indirizzoNascita?.localita,
            provinciaNascita: outcome.output.beneficiaries.anagrafica?.indirizzoNascita?.provincia,
            nazioneNascita: outcome.output.beneficiaries.anagrafica?.indirizzoNascita?.nazione,
            localitaProvincia: outcome.output.beneficiaries.anagrafica?.indirizzoNascita?.localita,
            relazione: outcome.output.beneficiaries.anagrafica?.relazione,
            relazioneDescrizione: outcome.output.beneficiaries.beneficiario?.relazione,
            via: outcome.output.beneficiaries.anagrafica?.indirizzo?.via,
            indirizzo: outcome.output.beneficiaries.anagrafica?.indirizzo?.via,
            cap: outcome.output.beneficiaries.anagrafica?.indirizzo.cap,
            provincia: outcome.output.beneficiaries.anagrafica?.indirizzo.provincia,
            nazione: outcome.output.beneficiaries.anagrafica?.indirizzo.nazione,
            sesso: outcome.output.beneficiaries.anagrafica?.sesso,
            dataNascita: outcome.output.beneficiaries.anagrafica?.dataNascita,
            localita: outcome.output.beneficiaries.anagrafica?.indirizzo.localita,
            codiceTipoBeneficiario: outcome.output.beneficiaries.beneficiario.codiceTipoBeneficiario
          });
          
          this.emitBeneficiariesList.emit(this.currentBeneficiaries);
        }}
      )
  }

  ngOnChanges(): void {
    // Placeholder for any logic that might be needed when input properties change
  }

  evaluateCodiceBeneficiario(codice: string) {
    return this.beneficiariesTypes.find(type => type.key === codice)?.value;
  }

}
